import { render, staticRenderFns } from "./QuoteCustomerSpecialPricingCard.vue?vue&type=template&id=06104ffd&"
import script from "./QuoteCustomerSpecialPricingCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteCustomerSpecialPricingCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports